<template>
  <b-form-group
    label="Haber Tarihi"
    label-for="ndate"
  >
    <validation-provider
      #default="{ errors }"
      name="Başlık"
      rules="required"
    >
      <b-form-datepicker
        id="ndate"
        v-model="itemData.ndate"
        placeholder="Haber Tarihi"
        locale="tr"
        v-bind="{labelNoDateSelected: 'Başlangıç Tarihi',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import { BFormGroup, BFormDatepicker } from 'bootstrap-vue'

export default {
  name: 'NDate',
  components: {
    BFormGroup,
    BFormDatepicker,
    ValidationProvider,
  },
  computed: {
    itemData() {
      return this.$store.getters['press/dataItem']
    },
  },
}
</script>
